export const SYMPTOM_CHEAKER = {
  key: 'SYMPTOM_CHEAKER',
  value: 1,
  group: 1,
  title: 'health-record.symptomcheaker.symptomcheaker_title',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Symptom-Checker.svg'),
  menu_title: 'health-record.symptomcheaker.title',
  icon: 'file-check',
  editor: 'SymptomcheakerEditor',
  message_translate: 'health-record.conditions.message',
  model_name: 'symptomcheaker',
  resource: 'hr/symptomcheaker/',
  plain_resource: 'symptomcheaker',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.conditions.condition',
      value: 'record.condition',
    },
    {
      text: 'health-record.conditions.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.conditions.end-date',
      value: 'record.end_formatted',
    },
    {
      text: 'health-record.conditions.verification-status',
      value: 'record.verification_status.value',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      end_formatted: 'end',
      condition: 'symptomcheaker',
      verification_status: {
        value: 'verification_status',
      },
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #ad1457 3.07%, #d81b60 100%)',
  color: '#D81B60',
  opaque: '#F3CDDB',
}
